"use client";
import React from "react";
import Link from "next/link";
import { IconButton, Flex, Text } from "@chakra-ui/react";
import { IoArrowForward } from "@onemind-services-llc/react-icons-ng/io5";
import { useDashboardLoginURL } from "@/hooks/useDashboardLoginURL";

type Props = {
  id: number;
  display: string;
  product_id: number;
  category_id: number;
};

const RenderBuyNow = (props: Props) => {
  const { id, display, category_id, product_id } = props;
  const dashboardLoginURL = useDashboardLoginURL();

  let nextURL = `/app/learning-labs/buy-product/${id}?product=`;
  nextURL +=
    '{"display": "' +
    display +
    '", "product_id": ' +
    product_id +
    ', "category_id": ' +
    category_id +
    ', "account_host": "cmlbooking.checkfront.com"}';

  const href = `${dashboardLoginURL}?next=${encodeURIComponent(nextURL)}`;

  return (
    <Link href={href}>
      <Flex
        align="center"
        bg="brand.100"
        color="white"
        width={"fit-content"}
        borderRadius={"4px"}
      >
        <Text ml={2}>Buy </Text>
        <IconButton
          aria-label="Buy Now"
          title="Buy Now"
          bg="brand.100"
          color="white"
          icon={<IoArrowForward />}
          size="sm"
          _hover={{ backgroundColor: "brand.100", color: "white" }}
        />
      </Flex>
    </Link>
  );
};

export default RenderBuyNow;
